import createAnswer from "./createAnswer";
import deleteAnswer from "./deleteAnswer";
import editAnswer from "./editAnswer";

const checkAnswers = async (savedAnswers, updatedAnswers, questionId) => {
	const savedIds = savedAnswers.reduce(
		(acc, answer) => ({ ...acc, [answer.id]: true }),
		{}
	);
	if (savedAnswers) {
		for (const savedAnswer of savedAnswers) {
			if (updatedAnswers[savedAnswer.id]) {
				if (
					!updatedAnswers[savedAnswer.id].files?.length &&
					!updatedAnswers[savedAnswer.id].text
				) {
					await deleteAnswer(savedAnswer.id);
				}
				await editAnswer(
					updatedAnswers[savedAnswer.id],
					savedAnswer,
					questionId,
					savedAnswer.id,
					"choosing"
				);
			}
			if (!updatedAnswers[savedAnswer.id]) {
				await deleteAnswer(savedAnswer.id);
			}
		}
	}
	if (updatedAnswers) {
		for (const indexAnswerKey in updatedAnswers) {
			if (!savedIds[indexAnswerKey]) {
				await createAnswer(
					updatedAnswers[indexAnswerKey],
					questionId,
					indexAnswerKey,
					"choosing"
				);
			}
		}
	}
};

export default checkAnswers;
